import { LogError } from "./ErrorTelemetry";
import { LogEventNames } from "../backend/interfaces/ITelemetryLogger";

// Monitors for global uncaught errors
let errorArea: LogEventNames = LogEventNames.Error;

// If an error is detected, we format an error message and log it
const onError = (event: string | ErrorEvent, source?: string, lineno?: number, colno?: number, error?: Error) => {
    let errorMessage: string = "ErrorMonitor detected error. Event: ";
    if (typeof event === 'string')
        errorMessage += event;
    else
        errorMessage += event.message;

    if (source)
        errorMessage += ", source: " + source;
    if (lineno)
        errorMessage += ", lineno: " + lineno;
    if (colno)
        errorMessage += ", colno: " + colno;
    if (error) {
        errorMessage += ", error.name: " + error.name;
        errorMessage += ", error.message: " + error.message;
    }

    LogError(errorArea, errorMessage);
}

// Starts the global monitor that keeps track of any errors thrown
export function Start(errorAreaIn: LogEventNames) {
    errorArea = errorAreaIn;
    window.addEventListener('error', onError);
}

export function SetErrorArea(errorAreaIn: LogEventNames) {
    errorArea = errorAreaIn;
}